import { render, staticRenderFns } from "./work-item.view.vue?vue&type=template&id=696153ed&scoped=true&"
import script from "./work-item.view.vue?vue&type=script&lang=ts&"
export * from "./work-item.view.vue?vue&type=script&lang=ts&"
import style0 from "./work-item.view.vue?vue&type=style&index=0&id=696153ed&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696153ed",
  null
  
)

export default component.exports